import React from "react";
import { Link } from "react-router-dom";
import { FiPlus, FiBriefcase } from "react-icons/fi";
import "./PropertyPageHeader.css";

const PropertyPageHeader = ({
  title = "Shared Properties",
  description = "Browse premium real estate, residential developments, plots, commercial listings, and exclusive property options.",
  onOpenCreate,
  canCreate = true,
  totalCount,
  createLink = "/property/add-property",
}) => {
  return (
    <div className="property-page-header">
      <div className="property-page-header__content">
        <div className="property-page-header__badge">
          <FiBriefcase className="property-page-header__badge-icon" />
          <span>Property Hub</span>
          {typeof totalCount === "number" && (
            <span className="property-page-header__count-tag">{totalCount} Listed</span>
          )}
        </div>
        <h1 className="property-page-header__title">{title}</h1>
        <p className="property-page-header__description">{description}</p>
      </div>

      {canCreate && (
        <div className="property-page-header__actions">
          {onOpenCreate ? (
            <button
              type="button"
              className="property-page-header__create-btn"
              onClick={onOpenCreate}
            >
              <FiPlus size={18} />
              <span>Add Property</span>
            </button>
          ) : (
            <Link to={createLink} className="property-page-header__create-btn">
              <FiPlus size={18} />
              <span>Add Property</span>
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default PropertyPageHeader;
